import * as React from "react";
import Shop from "../../_data/models/Shop";
import SearchResult from "../../_data/models/SearchResult";
import LikeContainer from "../../_widgets/like/LikeContainer";

interface Props {
    result: SearchResult;
    shop: Shop;
    viewItem: () => void;
}

const SearchTrendingShopComponent = (props: Props) => {
    const {result, shop, viewItem} = props;

    return (
        <div className="medium-6 columns">
            <div onClick={viewItem}>
                <div className="newsfeed-panel callout paddingless mb-half">
                    <div className="row">
                        <div className="large-12 columns">
                            <div className="post-img fixed-size v-align-center">
                                <img src={shop.primaryPictureUrl || window.Styleteq.images.stPlaceholder}/>
                                <div className="text-wrapper">
                                    <h5>{shop.name}</h5>
                                    {result.distance &&
                                    <h6>{result.distanceInMiles()} Miles</h6>
                                    }
                                    <h6 className="subheader">{shop.completeAddress()}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row p1 paddingless">
                        <div className="large-12 columns">
                            <ul className="list-inline marginless newsfeed-lgfont">
                                <LikeContainer model={shop}/>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default SearchTrendingShopComponent;


// WEBPACK FOOTER //
// ./app/client/search/components/SearchTrendingShopComponent.tsx